import { PaymentInfoSectionCombinedProps } from './types';

const usePresenter = (props: PaymentInfoSectionCombinedProps): PaymentInfoSectionCombinedProps => {
  return props;
};

export default usePresenter;
